module.exports = __webpack_public_path__ + "static/media/risk-based-principle.4c01f7db.pdf";